import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

export const teamCreationExp: UFOExperience = new UFOExperience('team-creation-action', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
	platform: { component: 'people' },
});
